RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CurationLayout = App.views.Layout.extend({
        template: '#dashboardCurationLayoutTemplate',
        regions: {
            regionContainer: '.dashboard-regions',
            actions: {
                selector: '.x-toolbar-actions-region',
                regionClass: RivalIQ.regions.ListRegion
            },
            leftActions: {
                selector: '.x-left-actions-region',
                regionClass: RivalIQ.regions.ListRegion
            }
        },
        childView: RivalIQ.apps.Dashboard.views.Widgets,
        onRenderLoaded: function () {
            const me = this;
            me.showToolbars();
        },

        showToolbars: function () {
            const me = this;
            me.showLeftToolbarActions();
            me.showActions();
        },

        showActions: function () {
            const me = this;
            me.showExportDropdown();
        },

        showLeftToolbarActions: _.noop,

        showExportDropdown: function () {
            const me = this;

            me.actions.show(new App.views.ExportDropdown({
                model: me.dashboardModel
            }), {
                preventDestroy: true
            });
        },
        onLoadDataError: function (error) {
            const me = this;

            if (error) {
                me.loadingView.$el.css('height', 'auto');
                me.loadingView.$el.addClass('widget-error');
                me.loadingView.$el.html(Marionette.TemplateCache.get('#widgetErrorView')());

                if (me.dashboardModel.isExporting()) {
                    RivalIQ.export.failExport(_.get(error, ['responseJSON', 'error', 'message'], error));
                }
            }
        }
    });

    views.PdfCurationLayout = App.views.Layout.extend({
        template: '#dashboardPdfCurationLayoutTemplate',

        serializeData: function () {
            const me = this;
            const tagName = me.getCompanySetName();

            return {
                title: me.dashboardModel.title,
                subtitle: '',
                hasCompanySet: Boolean(tagName),
                tagName: tagName,
                // TODO clean up
                timePeriod: me.dashboardModel.getExportTitleBarTimePeriod(),
                branding: RivalIQ.state.view.get('branding') || RivalIQ.state.view.getActiveBranding().toJSON(),
                landscapeName: RivalIQ.state.view.get('landscapeName')
            };
        },

        getCompanySetName: function () {
            // only include the companySet name if the companySet is not "All" and companySets make sense for this page
            if (RivalIQ.state.view.get('companySetDescriptor') !== RivalIQ.state.companySets.none && RivalIQ.apps.Shell.isCompanySetFilteringEnabled()) {
                return RivalIQ.state.view.getCompanySetName();
            }
        }
    });
});
